class FadingImages {
  constructor(section) {
    this.section = section;
    this.slides = Array.from(section.querySelectorAll('.fading-images__item'));
    this.currentIndex = 0;
    this.interval = parseInt(section.dataset.interval) || 5000;
    this.init();
  }

  init() {
    this.slides.forEach((slide) => {
      slide.style.position = 'absolute';
      slide.style.top = '0';
      slide.style.left = '0';
      slide.style.width = '100%';
      slide.style.height = '100%';
      slide.style.transition = 'opacity 2s ease-in-out';
      slide.style.transform = 'scale(1)';
      slide.style.willChange = 'opacity';
    });

    this.section.style.position = 'relative';

    var firstImg = this.slides[0] && this.slides[0].querySelector('img');
    if (firstImg) {
      if (firstImg.complete && firstImg.naturalWidth > 0) {
        this.section.classList.add('image-ready');
      } else {
        firstImg.addEventListener('load', () => {
          this.section.classList.add('image-ready');
        });
        firstImg.addEventListener('error', () => {
          this.section.classList.add('image-ready');
        });
      }
    } else {
      this.section.classList.add('image-ready');
    }

    if (this.slides.length > 1) setInterval(() => this.next(), this.interval);
  }

  next() {
    this.slides[this.currentIndex].style.opacity = '0';
    this.slides[this.currentIndex].style.transform = 'scale(1)';
    this.currentIndex = (this.currentIndex + 1) % this.slides.length;
    this.slides[this.currentIndex].style.transform = 'scale(1)';
    this.slides[this.currentIndex].style.opacity = '1';
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.slides[this.currentIndex].style.transform = 'scale(1.05)';
      });
    });
  }
}

document.querySelectorAll('.fading-images').forEach(el => new FadingImages(el));
